module.exports = __webpack_public_path__ + "img/143.c32a586c.svg";